
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cpd/cpd-privacy-policy",
      function () {
        return require("private-next-pages/cpd/cpd-privacy-policy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cpd/cpd-privacy-policy"])
      });
    }
  